import './LicenseSeatDeactivation.scss';
import * as React from 'react';
import * as Core from 'components/core';
import CloseModal from 'app/actionCreators/CloseModal';
import BeginDeactivation from 'app/actionCreators/BeginDeactivation';
import { LicenseSeat, LicenseSeatActivation } from 'types/license';
type Props = {
  licenseSeat: LicenseSeat | undefined | null;
  licenseSeatActivation: LicenseSeatActivation | undefined | null;
};
export default class LicenseSeatDeactivation extends React.Component<Props> {
  beginDeactivation = () => {
    const { licenseSeat, licenseSeatActivation } = this.props;
    if (licenseSeat == null || licenseSeatActivation == null) {
      return;
    }
    BeginDeactivation({
      SeatID: licenseSeat.ID,
      MachineID: licenseSeatActivation.MachineID,
    });
  };
  render() {
    const { licenseSeat, licenseSeatActivation } = this.props;
    if (licenseSeat == null || licenseSeatActivation == null) {
      return null;
    }
    return (
      <div className="LicenseSeatDeactivation">
        <div className="LicenseSeatDeactivation-heading">
          Remote Deactivation
        </div>

        <div className="LicenseSeatDeactivation-instructions">
          <p>
            Proceeding will deactivate this license seat on the computer that’s
            currently using it, and make it available to install on another
            computer.
          </p>

          <p>
            The next time QLab opens on the original computer, the deactivated
            license seat will be uninstalled automatically.
          </p>

          <p>
            Click{' '}
            <Core.Link
              newWindow
              to="/docs/v4/general/licenses/#remote-deactivation"
            >
              here
            </Core.Link>{' '}
            for more information on remote deactivation.
          </p>
        </div>

        <Core.FormGroup>
          <div className="OfflineActivation-form">
            <Core.Button onClick={this.beginDeactivation}>
              Deactivate
            </Core.Button>

            <Core.Button color="white" onClick={CloseModal}>
              Cancel
            </Core.Button>
          </div>
        </Core.FormGroup>
      </div>
    );
  }
}
